import React from 'react';
import { RouteComponentProps } from 'react-router';
import { ContentWrapper } from '../../components/content_wrapper/content_wrapper';
import { ScrollToTop } from '../../components/scroll_to_top/scroll_to_top';
import { MediaListContainer } from './media_list_container';

const MediaPage = (props: RouteComponentProps<{}>) => {
  return (
    <ScrollToTop>
      <ContentWrapper>
        <MediaListContainer />
      </ContentWrapper>
    </ScrollToTop>
  );
};

export default MediaPage;
